<template>
  <div id="autcomplete-paciente" :class="'autcomplete-paciente-' + color">
    <az-input 
      placeholder="Paciente"
      icon2="fas fa-search"
      type="autocomplete" 
      optionsMode="aql"
      service="pacientes.index"
      optionsDisplay="search"
      v-model="paciente" 
      :shortkey="['ctrl', 'm']" 
      :optimized_ac="true"
      :optionsParm="{ bm: 1 }"
      @onEnter="focusOn('info_plano')"
      @input="selecionarPaciente()">
      <template v-slot:buttonposb>
        <div class="input-group-append" v-if="cache && cache.length">
            <button type="button" class="btn btn-link" :class="'text-' + color" @click="abrir_recentes()" title="Pacientes Recentes.">
                <i class="fa-solid fa-rectangle-history-circle-user"></i>
            </button>
        </div>
      </template>
    </az-input>
  
  </div>
</template>

<script>
import AzInput from './forms/AzInput.vue';

export default {
  name: "AutocompletePaciente",
  data() {
    return {
      paciente: null, 
      nomePaciente: "",
      results: null,
      isFocus: null,
      cache: [],
    };
  },
  props: ['color'],
  methods: {
    abrir_recentes () { 
        console.log('abrir recentes', this.cache);
        this.$emit('recentes', this.cache);
    },

    salvar_cache() {
        if ( !this.paciente )
            return;

        if ( this.paciente.id_cadastro_temporario ) { 
            
            let idx = this.cache.findIndex(item => item.tmp && item.id == this.paciente.id_cadastro_temporario);

            if ( idx >= 0 ) { 
                this.cache.splice(idx, 1);
            }

            this.cache.push({ 
                tmp: true, 
                id: this.paciente.id_cadastro_temporario,
                id_cadastro_temporario: this.paciente.id_cadastro_temporario,
                st_nome: this.paciente.st_nome, 
                search: this.paciente.search, 
            });

        } else { 

            let idx = this.cache.findIndex(item => !item.tmp && item.id == this.paciente.id_pessoa);

            if ( idx >= 0 ) { 
                this.cache.splice(idx, 1);
            }

            this.cache.push({ 
                tmp: false, 
                id: this.paciente.id_pessoa,
                id_pessoa: this.paciente.id_pessoa,
                st_nome: this.paciente.st_nome, 
                search: this.paciente.search, 
            });

            
        }

        if ( this.cache.length > 10 ) { 
            this.cache.slice(this.cache.length - 9);
        }
            
    },

    selecionarPaciente () { 
      if ( this.paciente ) { 

        this.salvar_cache();
        
        //console.log(this.$root);
        //$('#perfilPacienteModal').modal('show');
        //this.$root.$children[0].$refs.perfil.abrir(this.paciente);
        if ( this.paciente.id_cadastro_temporario ) { 
          this.$root.perfil_temp(this.paciente);
        } else { 
          this.$root.perfil(this.paciente);
        }

        
        this.$nextTick(() => {
          this.paciente = null;
        });
      }
    },
    focusOn () { 
      //
    },
    async search() {
      /*
      if (ev.query.length >= 2) {
        let query = {
          q: [
            {
              name: "pacientes.index",
              id: "resultado",
              parms: { search: ev.query }
            }
          ]
        };
        this.axios.post("aql", query).then(res => {
          this.results = res.data.resultado.data;
        });
      }
      */
    }
  },
  components: { 
    AzInput 
  }
};
</script>

<style>
.autcomplete-paciente-light input { 
  background-color: transparent !important;
  color: white !important;
  border: none !important;
  border-bottom: 1px solid white !important;

  width: 350px !important;
  
  -webkit-transition: all .5s;
  -moz-transition: all .5s;
  transition: all .5s;
}

.autcomplete-paciente-dark input { 
  background-color: transparent !important;
  color: black !important;
  border: none !important;
  border-bottom: 1px solid black !important;

  width: 350px !important;
  
  -webkit-transition: all .5s;
  -moz-transition: all .5s;
  transition: all .5s;
}

.autcomplete-paciente-light input::placeholder {
    /* modern browser */
    color: whitesmoke !important;
}

.autcomplete-paciente-dark input::placeholder {
    /* modern browser */
    color: gray !important;
}

.autocomplete-results { 
    width: 112% !important;
}
</style>